module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-menu-clone",
    attrs: {
      "id": "printable"
    }
  }, [_c('page-bar', {
    staticClass: "no-print"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Cardápio mensal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-right no-print"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/meal-menu"
    }
  }, [_vm._v("\n\t\t\t\tVoltar\n\t\t\t")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn yellow-gold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.print('#printable')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\tImprimir\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet light full-calendar-printable"
  }, [_c('full-calendar', {
    attrs: {
      "config": _vm.calendarConfig,
      "header": {
        left: '',
        center: 'title',
        right: ''
      },
      "editable": false,
      "events": _vm.events
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d976b98c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/meal-menu/monthly/main.vue
// module id = 1113
// module chunks = 1